import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getOtp = id => {
  return http.get(
    `${getBaseUrl()}/otp/${id}`
  );
};

export const getOtps = () => {
  return http.get(
    `${getBaseUrl()}/otp`
  );
};

export const updateOtp = data => {

  return http.put(
    `${getBaseUrl()}/otp/${data.id}`,
    data
  );
};

export const submitOtp = data => {

  return http.post(
    `${getBaseUrl()}/otp`,
    data
  );
};
